import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { TemplateDetail } from './types/template-detail.type';

/**
 * Updates the details of a template by sending a PUT request to the API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param data - The template detail data to update.
 * @returns A promise that resolves to the operation result of the update.
 * @throws Throws an error if the request fails.
 */
export const updateTemplateDetail = async (instance: KyInstance, data: TemplateDetail) => {
  try {
    return await instance
      .put<OperationResult>(formatString(Uri.template.updateTemplateDetail, data.id?.toString() ?? ''), { json: data })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
